import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';
import Privacy from 'components/Privacy'
import './app.scss';

ReactGA.initialize('UA-142477757-1', { debug: process.env.NODE_ENV === 'development' });

@withRouter
@connect(state => state)
class App extends Component {
    componentDidMount() {
        ReactGA.pageview(window.location.pathname);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
            ReactGA.pageview(window.location.pathname);
        }
    }

    render() {
        const { i18n, children } = this.props;
        const { locale } = i18n;
        const [ lang ] = locale.split('-');
        const appClassName = classNames({
            'app': true,
            [locale.toLowerCase()]: true,
            [lang]: true,
        });

        return (
            <div className={ appClassName }>
                { children }
                <Privacy />
            </div>
        );
    }
}


export default App;
